import styled from 'styled-components';

export const StyledPlayerLabel = styled.div`
  display: flex;
  flex-direction: column;
  text-transform: uppercase;
  font-family: "NeueMachina";
  font-weight: 800;
  align-items: ${({ $you }) => $you ? 'start': 'end'};
  justify-content: start;
  color: white;
  padding: 2.5rem;
`;

export const PlayerLabelName = styled.div`
  font-size: ${({ $you }) => $you ? '8rem': '5rem'};
`;

export const PlayerLabelXp = styled.div`
  font-size: 3rem;
`;
